<app-playlist-layout *ngIf="playlist" [ctx]="ctx"></app-playlist-layout>
